"use client";

import React from "react";
import { Target, Eye, Diamond } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function MissionVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const items = [{
    title: "Structural Repairs",
    icon: Target,
    content: "Our team specializes in comprehensive hail damage restoration, major chassis overhauls, and expert panel replacement. We utilize industrial-grade materials to return your caravan to its original factory condition, ensuring structural integrity and safety for every journey across Sydney."
  }, {
    title: "Electrical & Solar",
    icon: Eye,
    content: "Power your off-grid adventures with our professional solar panel installations and advanced battery management systems. From air conditioner setups to complex plumbing and wiring, our licensed technicians ensure all technical components meet rigorous safety standards for peak performance."
  }, {
    title: "Maintenance Services",
    icon: Diamond,
    content: "Keep your caravan in optimal condition with our precision maintenance services, including brake checks, bearing re-greasing, and chassis inspections. Based in South Windsor, we provide seamless private and insurance repair services for all major caravan and motorhome makes."
  }];
  return <section data-section-id="35373" id="our-services" ref={ref} className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className={cn("container mx-auto px-6 transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="flex flex-col md:flex-row gap-8 md:gap-0 items-stretch justify-center">
          {items.map((item, index) => <React.Fragment key={index}>
              {}
              <div data-index={index} className="flex-1 flex flex-col items-center text-center px-4 md:px-8 group">
                <div className="mb-8 p-4 rounded-full bg-chart-2/10 shadow-sm ring-1 ring-chart-2/30 group-hover:ring-chart-2/60 transition-all duration-500">
                  <item.icon className="size-16 text-chart-2 stroke-[1.5px]" aria-hidden="true" />
                </div>
                <h3 className="text-3xl font-bold text-primary mb-6 tracking-tighter uppercase">
                  {item.title}
                </h3>
                <p className="text-foreground/80 leading-relaxed text-justify text-lg font-medium">
                  {item.content}
                </p>
              </div>

              {}
              {index < items.length - 1 && <>
                  <Separator orientation="vertical" className="hidden md:block h-auto min-h-[300px] w-[1px] bg-primary/10 mx-4" />
                  <Separator orientation="horizontal" className="md:hidden w-full h-[1px] bg-primary/10 my-8" />
                </>}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}